module.exports = __webpack_public_path__ + "static/media/rp_intro_banner.844fd99d.svg";